// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduleBookingDateTimeContainer {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.scheduleBookingDateTimeContainer .flatpickr-wrapper {
    flex-grow: 1;
}

.scheduleBookingDateTimeContainer .flatpickr-wrapper>input {
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);
    color: var(--primary-foreground);
    border-radius: var(--radius-1) 0 0 var(--radius-1);
    padding: 9px 10px 9px 18px;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    width: 100%;
    height: 44px;
    border-right: 0;
}

.scheduleBookingDateTimeContainer .flatpickr-wrapper>input:focus,
.scheduleBookingDateTimeContainer .flatpickr-wrapper>input:focus-visible {
    box-shadow: none;
    outline: 1px solid transparent;
}

.scheduleBookingDateTimeContainer .flatpickr-calendar.open {
    -webkit-user-select: none;
    user-select: none;
}

.scheduleBookingDateTimeContainer .flatpickr-calendar.arrowTop:before,
.scheduleBookingDateTimeContainer .flatpickr-calendar.arrowTop:after {
    border-bottom-color: var(--background-primary);
}

.scheduleBookingDateTimeContainer .flatpickr-months {
    position: relative;
}

.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-month {
    background: var(--background-primary);
    color: var(--primary-foreground);
    fill: var(--primary-foreground);
    height: 65px;
}

.scheduleBookingDateTimeContainer .flatpickr-current-month {
    padding: 18px 0 18px 0;
    height: 100%;
}

.scheduleBookingDateTimeContainer .flatpickr-current-month .flatpickr-monthDropdown-months {
    background: var(--common-hover-bg);
    background-image: inherit !important;
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    padding: 4px 12px 4px 4px;
    border-radius: 6px;
}

.scheduleBookingDateTimeContainer .flatpickr-current-month input.cur-year {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: var(--primary-foreground);
}

.scheduleBookingDateTimeContainer .flatpickr-current-month input.cur-year[disabled],
.scheduleBookingDateTimeContainer .flatpickr-current-month input.cur-year[disabled]:hover {
    font-size: 16px;
    color: var(--primary-foreground);
    background: transparent;
    pointer-events: none;
}

.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month,
.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month {
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid var(--primary-border);
    border-radius: 50%;
    color: var(--primary-foreground);
    fill: var(--primary-foreground);
    padding: 0;
}

.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month svg,
.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month svg {
    width: 16px;
    height: 16px;
}

.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
    right: 10px;
}

.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
    left: 10px;
}

.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month:hover svg,
.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month:hover svg {
    fill: var(--primary-foreground);
}


.scheduleBookingDateTimeContainer .flatpickr-month .numInputWrapper .arrowUp,
.scheduleBookingDateTimeContainer .flatpickr-month .numInputWrapper .arrowDown {
    display: none;
}

.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month.flatpickr-disabled {
    display: none;
}

.scheduleBookingDateTimeContainer .flatpickr-innerContainer,
.scheduleBookingDateTimeContainer .flatpickr-weekdays {
    background: var(--background-primary);
}

.scheduleBookingDateTimeContainer span.flatpickr-weekday {
    background: var(--background-primary);
    color: var(--primary-foreground);
}

.scheduleBookingDateTimeContainer .flatpickr-days {
    border-left: 1px solid var(--background-primary);
    border-right: 1px solid var(--background-primary);
}

.scheduleBookingDateTimeContainer .flatpickr-day {
    color: var(--primary-foreground);
}

.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled,
.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled:hover,
.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.notAllowed,
.scheduleBookingDateTimeContainer .flatpickr-day.notAllowed.prevMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.notAllowed.nextMonthDay {
    color: var(--secondary-foreground);
}

.scheduleBookingDateTimeContainer .flatpickr-day.today,
.scheduleBookingDateTimeContainer .flatpickr-day.today:hover,
.scheduleBookingDateTimeContainer .flatpickr-day.today:focus {
    border-color: var(--common-hover-bg);
    background: var(--common-hover-bg);
    color: var(--primary-foreground);
}

.scheduleBookingDateTimeContainer .flatpickr-day.selected,
.scheduleBookingDateTimeContainer .flatpickr-day.startRange,
.scheduleBookingDateTimeContainer .flatpickr-day.endRange,
.scheduleBookingDateTimeContainer .flatpickr-day.selected.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.startRange.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.endRange.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.selected:focus,
.scheduleBookingDateTimeContainer .flatpickr-day.startRange:focus,
.scheduleBookingDateTimeContainer .flatpickr-day.endRange:focus,
.scheduleBookingDateTimeContainer .flatpickr-day.selected:hover,
.scheduleBookingDateTimeContainer .flatpickr-day.startRange:hover,
.scheduleBookingDateTimeContainer .flatpickr-day.endRange:hover,
.scheduleBookingDateTimeContainer .flatpickr-day.selected.prevMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.startRange.prevMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.endRange.prevMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.selected.nextMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.startRange.nextMonthDay,
.scheduleBookingDateTimeContainer .flatpickr-day.endRange.nextMonthDay {
    background: var(--primary-bg);
    border-color: var(--primary-bg);
    color: var(--common-primary-white-foreground);
}

.scheduleBookingDateTimeContainer .flatpickr-day.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.today.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay.today.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay.today.inRange,
.scheduleBookingDateTimeContainer .flatpickr-day:hover,
.scheduleBookingDateTimeContainer .flatpickr-day:focus,
.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay:hover,
.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay:hover,
.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay:focus,
.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay:focus {
    background: var(--common-hover-bg);
    border-color: var(--common-hover-bg);
}

.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled,
.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled:hover,
.scheduleBookingDateTimeContainer .latpickr-day.flatpickr-disabled:focus {
    background: transparent;
    border-color: transparent;
}


.scheduleBookingDateTimeContainer .flatpickr-calendar.hasTime .flatpickr-time {
    border: none;
    border-top: 1px solid var(--primary-border);
    background: var(--background-primary);
}

.scheduleBookingDateTimeContainer .flatpickr-time input {
    color: var(--primary-foreground);
}

.scheduleBookingDateTimeContainer .numInputWrapper span:hover {
    background: var(--common-hover-bg);
}

.scheduleBookingDateTimeContainer .flatpickr-time input:hover,
.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-am-pm:hover,
.scheduleBookingDateTimeContainer .flatpickr-time input:focus,
.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-am-pm:focus {
    background: var(--common-hover-bg);
}

.scheduleBookingDateTimeContainer .flatpickr-time .numInputWrapper span.arrowUp:after {
    border-bottom-color: var(--number-icon-arrow-bg);
}

.scheduleBookingDateTimeContainer .flatpickr-time .numInputWrapper span.arrowDown:after {
    border-top-color: var(--number-icon-arrow-bg);
}

.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-time-separator,
.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-am-pm {
    color: var(--primary-foreground);
}

/* rtl */

.rtl .scheduleBookingDateTimeContainer .flatpickr-wrapper>input {
    border-right: 1px solid var(--primary-border);
    border-left: 0;
    border-radius: 0 var(--radius-1) var(--radius-1) 0;
    padding: 9px 18px 9px 10px;
}

.rtl .scheduleBookingDateTimeContainer .flatpickr-calendar:before,
.rtl .scheduleBookingDateTimeContainer .flatpickr-calendar:after {
    left: unset;
    right: 22px;
}

.rtl .scheduleBookingDateTimeContainer .flatpickr-current-month .flatpickr-monthDropdown-months {
    padding: 4px 12px 4px 4px !important;
}

/* dark mode */

.darkMode .flatpickr-current-month select {
    background-image: inherit !important;
}

/* media */

@media (max-width:340px) {
    .scheduleBookingDateTimeContainer .flatpickr-calendar {
        left: -13px;
    }

    .rtl .scheduleBookingDateTimeContainer .flatpickr-calendar {
        left: unset;
        right: -13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/flatPickerCalendar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,mCAAmC;IACnC,gCAAgC;IAChC,kDAAkD;IAClD,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;;IAEI,eAAe;IACf,gCAAgC;IAChC,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;;IAEI,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,+BAA+B;AACnC;;;AAGA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;;;;;IAOI,kCAAkC;AACtC;;AAEA;;;IAGI,oCAAoC;IACpC,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;;;;;;;;;;;;;;;;;;IAkBI,6BAA6B;IAC7B,+BAA+B;IAC/B,6CAA6C;AACjD;;AAEA;;;;;;;;;;;;IAYI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;;;IAGI,uBAAuB;IACvB,yBAAyB;AAC7B;;;AAGA;IACI,YAAY;IACZ,2CAA2C;IAC3C,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;;;IAII,kCAAkC;AACtC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA,QAAQ;;AAER;IACI,6CAA6C;IAC7C,cAAc;IACd,kDAAkD;IAClD,0BAA0B;AAC9B;;AAEA;;IAEI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA,cAAc;;AAEd;IACI,oCAAoC;AACxC;;AAEA,UAAU;;AAEV;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".scheduleBookingDateTimeContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-wrapper {\n    flex-grow: 1;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-wrapper>input {\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n    color: var(--primary-foreground);\n    border-radius: var(--radius-1) 0 0 var(--radius-1);\n    padding: 9px 10px 9px 18px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    width: 100%;\n    height: 44px;\n    border-right: 0;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-wrapper>input:focus,\n.scheduleBookingDateTimeContainer .flatpickr-wrapper>input:focus-visible {\n    box-shadow: none;\n    outline: 1px solid transparent;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-calendar.open {\n    -webkit-user-select: none;\n    user-select: none;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-calendar.arrowTop:before,\n.scheduleBookingDateTimeContainer .flatpickr-calendar.arrowTop:after {\n    border-bottom-color: var(--background-primary);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months {\n    position: relative;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-month {\n    background: var(--background-primary);\n    color: var(--primary-foreground);\n    fill: var(--primary-foreground);\n    height: 65px;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-current-month {\n    padding: 18px 0 18px 0;\n    height: 100%;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-current-month .flatpickr-monthDropdown-months {\n    background: var(--common-hover-bg);\n    background-image: inherit !important;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 26px;\n    padding: 4px 12px 4px 4px;\n    border-radius: 6px;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-current-month input.cur-year {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 26px;\n    color: var(--primary-foreground);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-current-month input.cur-year[disabled],\n.scheduleBookingDateTimeContainer .flatpickr-current-month input.cur-year[disabled]:hover {\n    font-size: 16px;\n    color: var(--primary-foreground);\n    background: transparent;\n    pointer-events: none;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month,\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month {\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border: 1px solid var(--primary-border);\n    border-radius: 50%;\n    color: var(--primary-foreground);\n    fill: var(--primary-foreground);\n    padding: 0;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month svg,\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month svg {\n    width: 16px;\n    height: 16px;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n    right: 10px;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n    left: 10px;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month:hover svg,\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month:hover svg {\n    fill: var(--primary-foreground);\n}\n\n\n.scheduleBookingDateTimeContainer .flatpickr-month .numInputWrapper .arrowUp,\n.scheduleBookingDateTimeContainer .flatpickr-month .numInputWrapper .arrowDown {\n    display: none;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-prev-month.flatpickr-disabled,\n.scheduleBookingDateTimeContainer .flatpickr-months .flatpickr-next-month.flatpickr-disabled {\n    display: none;\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-innerContainer,\n.scheduleBookingDateTimeContainer .flatpickr-weekdays {\n    background: var(--background-primary);\n}\n\n.scheduleBookingDateTimeContainer span.flatpickr-weekday {\n    background: var(--background-primary);\n    color: var(--primary-foreground);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-days {\n    border-left: 1px solid var(--background-primary);\n    border-right: 1px solid var(--background-primary);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-day {\n    color: var(--primary-foreground);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled,\n.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.notAllowed,\n.scheduleBookingDateTimeContainer .flatpickr-day.notAllowed.prevMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.notAllowed.nextMonthDay {\n    color: var(--secondary-foreground);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-day.today,\n.scheduleBookingDateTimeContainer .flatpickr-day.today:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day.today:focus {\n    border-color: var(--common-hover-bg);\n    background: var(--common-hover-bg);\n    color: var(--primary-foreground);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-day.selected,\n.scheduleBookingDateTimeContainer .flatpickr-day.startRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.endRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.selected.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.startRange.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.endRange.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.selected:focus,\n.scheduleBookingDateTimeContainer .flatpickr-day.startRange:focus,\n.scheduleBookingDateTimeContainer .flatpickr-day.endRange:focus,\n.scheduleBookingDateTimeContainer .flatpickr-day.selected:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day.startRange:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day.endRange:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day.selected.prevMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.startRange.prevMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.endRange.prevMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.selected.nextMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.startRange.nextMonthDay,\n.scheduleBookingDateTimeContainer .flatpickr-day.endRange.nextMonthDay {\n    background: var(--primary-bg);\n    border-color: var(--primary-bg);\n    color: var(--common-primary-white-foreground);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-day.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.today.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay.today.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay.today.inRange,\n.scheduleBookingDateTimeContainer .flatpickr-day:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day:focus,\n.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay:hover,\n.scheduleBookingDateTimeContainer .flatpickr-day.prevMonthDay:focus,\n.scheduleBookingDateTimeContainer .flatpickr-day.nextMonthDay:focus {\n    background: var(--common-hover-bg);\n    border-color: var(--common-hover-bg);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled,\n.scheduleBookingDateTimeContainer .flatpickr-day.flatpickr-disabled:hover,\n.scheduleBookingDateTimeContainer .latpickr-day.flatpickr-disabled:focus {\n    background: transparent;\n    border-color: transparent;\n}\n\n\n.scheduleBookingDateTimeContainer .flatpickr-calendar.hasTime .flatpickr-time {\n    border: none;\n    border-top: 1px solid var(--primary-border);\n    background: var(--background-primary);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-time input {\n    color: var(--primary-foreground);\n}\n\n.scheduleBookingDateTimeContainer .numInputWrapper span:hover {\n    background: var(--common-hover-bg);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-time input:hover,\n.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-am-pm:hover,\n.scheduleBookingDateTimeContainer .flatpickr-time input:focus,\n.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-am-pm:focus {\n    background: var(--common-hover-bg);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-time .numInputWrapper span.arrowUp:after {\n    border-bottom-color: var(--number-icon-arrow-bg);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-time .numInputWrapper span.arrowDown:after {\n    border-top-color: var(--number-icon-arrow-bg);\n}\n\n.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-time-separator,\n.scheduleBookingDateTimeContainer .flatpickr-time .flatpickr-am-pm {\n    color: var(--primary-foreground);\n}\n\n/* rtl */\n\n.rtl .scheduleBookingDateTimeContainer .flatpickr-wrapper>input {\n    border-right: 1px solid var(--primary-border);\n    border-left: 0;\n    border-radius: 0 var(--radius-1) var(--radius-1) 0;\n    padding: 9px 18px 9px 10px;\n}\n\n.rtl .scheduleBookingDateTimeContainer .flatpickr-calendar:before,\n.rtl .scheduleBookingDateTimeContainer .flatpickr-calendar:after {\n    left: unset;\n    right: 22px;\n}\n\n.rtl .scheduleBookingDateTimeContainer .flatpickr-current-month .flatpickr-monthDropdown-months {\n    padding: 4px 12px 4px 4px !important;\n}\n\n/* dark mode */\n\n.darkMode .flatpickr-current-month select {\n    background-image: inherit !important;\n}\n\n/* media */\n\n@media (max-width:340px) {\n    .scheduleBookingDateTimeContainer .flatpickr-calendar {\n        left: -13px;\n    }\n\n    .rtl .scheduleBookingDateTimeContainer .flatpickr-calendar {\n        left: unset;\n        right: -13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
